import classNames from "classnames";
import { isPresent } from "neetocist";
import { useBreakpoints } from "neetocommons/react-utils";
import { Typography } from "neetoui";

import IntegrationItem from "./IntegrationItem";
import Item from "./Item";

const Category = ({ items, label, id, isIntegration }) => {
  const { isSize } = useBreakpoints();
  const SettingsCard = isIntegration ? IntegrationItem : Item;
  const isMobileOrTablet = isSize("mobile") || isSize("tablet");

  const isLabelPresent = isPresent(label);

  return (
    <div
      {...{ id }}
      className={classNames("flex flex-col", { "mb-7": isLabelPresent })}
    >
      {isLabelPresent && (
        <Typography
          className="mt-2 mb-6"
          component="h2"
          data-testid="settings-category-heading"
          style="h2"
          weight="semibold"
        >
          {label}
        </Typography>
      )}
      <div
        className={classNames(
          "grid grid-cols-1 gap-3 py-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-4",
          {
            "xl:grid-cols-2 2xl:grid-cols-3": isIntegration,
            "xl:grid-cols-3 2xl:grid-cols-4": !isIntegration,
          }
        )}
      >
        {items.map(item => (
          <SettingsCard
            key={item.label}
            {...item}
            {...(isIntegration && { isMobileOrTablet })}
          />
        ))}
      </div>
    </div>
  );
};

export default Category;
